export default "__VITE_ASSET__1dbe410b__"